import React from "react";
import { CheckCircle2, XCircle, AlertTriangle, MinusCircle } from "lucide-react";

const MAP = {
  PASS: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CheckCircle2, label: "Pass" },
  FAIL: { cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle, label: "Fail" },
  NEEDS_REVIEW: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: AlertTriangle, label: "Needs review" },
  NOT_APPLICABLE: { cls: "bg-slate-50 text-slate-500 border-slate-200", Icon: MinusCircle, label: "N/A" },
  ready: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CheckCircle2, label: "Ready" },
  ready_with_exception: { cls: "bg-indigo-50 text-indigo-700 border-indigo-200", Icon: AlertTriangle, label: "Ready · exception" },
  blocked: { cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle, label: "Blocked" },
  needs_review: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: AlertTriangle, label: "Needs review" },
  review: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: AlertTriangle, label: "Review" },
  clear: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CheckCircle2, label: "Clear" },
  blocking: { cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle, label: "Blocking" },
  informational: { cls: "bg-sky-50 text-sky-700 border-sky-200", Icon: MinusCircle, label: "Info" },
};

export function ResultBadge({ value, className = "", ...rest }) {
  const m = MAP[value] || { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: MinusCircle, label: String(value || "—").replace(/_/g, " ") };
  const Icon = m.Icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${m.cls} ${className}`} {...rest}>
      <Icon size={12} /> {m.label}
    </span>
  );
}

export function SimBadge({ label = "DEMO · SIMULATED", className = "" }) {
  return (
    <span className={`inline-flex items-center rounded-sm bg-amber-100 text-amber-800 border border-amber-300 px-1.5 py-0.5 text-[10px] font-bold tracking-wider ${className}`} data-testid="sim-badge">
      {label}
    </span>
  );
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
